"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rcSlider = require("rc-slider");

var _FocusableHOC = require("wix-ui-core/dist/src/hocs/Focusable/FocusableHOC");

var _constants = require("./constants");

var _SliderSt = require("./Slider.st.css");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Slider/SliderHandle.js",
    _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SliderHandle = function SliderHandle(_ref) {
  var tooltipValue = _ref.tooltipValue,
      className = _ref.className,
      _ref$onFocusCustom = _ref.onFocusCustom,
      onFocusCustom = _ref$onFocusCustom === void 0 ? function () {} : _ref$onFocusCustom,
      _ref$onBlurCustom = _ref.onBlurCustom,
      onBlurCustom = _ref$onBlurCustom === void 0 ? function () {} : _ref$onBlurCustom,
      focusableOnFocus = _ref.focusableOnFocus,
      focusableOnBlur = _ref.focusableOnBlur,
      disabled = _ref.disabled,
      handleProps = _ref.handleProps,
      displayTooltip = _ref.displayTooltip,
      index = _ref.index,
      dataHook = _ref.dataHook,
      direction = _ref.direction;

  var _useState = (0, _react.useState)(false),
      hovered = _useState[0],
      setHovered = _useState[1];

  var tooltipRef = _react["default"].useRef(null);

  var handleMouseEnter = function handleMouseEnter() {
    setHovered(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setHovered(false);
  };

  var handleOnFocus = function handleOnFocus(event) {
    focusableOnFocus();
    tooltipRef.current.open();
    onFocusCustom(Number(tooltipValue), event);
  };

  var handleOnBlur = function handleOnBlur(event) {
    focusableOnBlur();
    tooltipRef.current.close();
    onBlurCustom(Number(tooltipValue), event);
  };

  var tooltipDataHook = dataHook ? "".concat(dataHook, "-").concat(_constants.dataHooks.sliderTooltip, "-").concat(index) : "".concat(_constants.dataHooks.sliderTooltip, "-").concat(index);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _SliderSt.st)(_SliderSt.classes.sliderHandleWrapper, {}, className),
    onBlur: handleOnBlur,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react["default"].createElement(_rcSlider.Handle, (0, _extends2["default"])({}, handleProps, {
    vertical: direction === 'vertical',
    onFocus: handleOnFocus,
    className: (0, _SliderSt.st)(_SliderSt.classes.sliderHandle, {
      disabled: disabled
    }),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-hook": _constants.dataHooks.sliderHandle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    ref: tooltipRef,
    className: _SliderSt.classes.sliderHandleTooltip,
    disabled: !displayTooltip || disabled || !tooltipValue,
    content: tooltipValue,
    moveBy: {
      y: 3
    },
    dataHook: tooltipDataHook,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _SliderSt.st)(_SliderSt.classes.sliderThumb, {
      hovered: hovered
    }),
    "data-hook": _constants.dataHooks.sliderThumb,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 11
    }
  }))));
};

SliderHandle.propTypes = {
  onFocusCustom: _propTypes["default"].func,
  onBlurCustom: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  displayTooltip: _propTypes["default"].bool,
  tooltipValue: _propTypes["default"].string,
  index: _propTypes["default"].number,
  dataHook: _propTypes["default"].string,
  handleProps: _propTypes["default"].shape({
    ref: _propTypes["default"].func.isRequired,
    offset: _propTypes["default"].number.isRequired,
    min: _propTypes["default"].number.isRequired,
    max: _propTypes["default"].number.isRequired,
    value: _propTypes["default"].number.isRequired,
    reverse: _propTypes["default"].bool,
    ariaLabel: _propTypes["default"].string
  }),
  direction: _propTypes["default"].oneOf(['horizontal', 'vertical'])
};
SliderHandle.defaultProps = {
  displayTooltip: true,
  reverse: false
};

var _default = (0, _FocusableHOC.withFocusable)(SliderHandle);

exports["default"] = _default;
//# sourceMappingURL=SliderHandle.js.map